import { convertHelpers } from 'global/common/convert'
import { grts, responseReducers } from './reducerHelpers/dispatchProps'

const _alphaLimit = 60

export const rts = {
  handleInit: 'handleInit',

  handleGo_next: 'handleGo_next',
  handleGo_back: 'handleGo_back',
  handleGo_backTo: 'handleGo_backTo',

  handleSet_appDataKeys: 'handleSet_appDataKeys',
  handleSet_appLinkData: 'handleSet_appLinkData',
  handleSet_backupData: 'handleSet_backupData',
  handleSet_currentConfirmationType: 'handleSet_currentConfirmationType',
  handleSet_currentDataLinks: 'handleSet_currentDataLinks',
  handleSet_currentResults: 'handleSet_currentResults',
  handleSet_selectedAppData: 'handleSet_selectedAppData',
  handleSet_selectedAppDataKey: 'handleSet_selectedAppDataKey',
  handleSet_selectedCollection: 'handleSet_selectedCollection',
  handleSet_selectedCollectionData: 'handleSet_selectedCollectionData',
  handleSet_selectedInfo: 'handleSet_selectedInfo',
  handleSet_selectedItems: 'handleSet_selectedItems',
  handleSet_updating: 'handleSet_updating',
  handleSet_useAlpha: 'handleSet_useAlpha',
  handleSet_clientProfiles: 'handleSet_clientProfiles',

  handleSelect_appData: 'handleSelect_appData',
  handleSelect_appDataItem: 'handleSelect_appDataItem',

  ...grts
}

export const appDataSidebarInitialState = (initState = { aps_viewItems }) => {
  return {
    appDataKeys: undefined,
    appLinkData: {},
    backupData: undefined,
    currentConfirmationType: undefined,
    currentDataLinks: undefined,
    currentResults: undefined,
    selectedAppData: {},
    selectedAppDataKey: {},
    selectedCollection: undefined,
    selectedCollectionData: undefined,
    selectedInfo: {
      appDataItemKey: null,
      appData: null,
      appDataItemItem: null,
      appDataItem: null,
      viewItem: null
    },
    selectedItems: {},
    updating: undefined,
    useAlpha: undefined,
    clientProfiles: undefined,
    allGroups: [{ key: 'appData' }],
    ...initState
  }
}

export const appDataSidebarReducer = (state, action) => {
  const { type, value } = action

  console.log('appDataSidebarReducer', action)

  switch (type) {
    case rts.handleInit:
      return { ...state }

    case rts.handleGo_next:
      const _allGroups = [...state.allGroups, { ...action.item, }]
      return {
        ...state,
        allGroups: _allGroups,
        direction: 'right',
      }

    case rts.handleGo_back:
      if (state.allGroups.length <= 1) { return state }
      return { ...state, allGroups: state.allGroups.slice(0, -1), direction: 'left', }

    case rts.handleGo_backTo:
      const { index } = action;
      if (index < 0 || index >= state.allGroups.length) return state
      if (state.allGroups.length <= 1) return state // ⛔ root protected 
      return {
        ...state,
        allGroups: state.allGroups.slice(0, index + 1)
      }

    case rts.handleSelect_appData:
      const { selected_info, _selectedAppData } = getSelectedInfo(action.item?.key, state)
      // console.log('selected_info', selected_info)
      let use_alpha = false
      if (_.size(selected_info?.appData) >= _alphaLimit) {
        use_alpha = true;
      }
      const _all_groups = [...state.allGroups, { ...action.item, }]
      return {
        ...state,
        selectedInfo: selected_info,
        selectedAppDataKey: value,
        selectedAppData: _selectedAppData,
        useAlpha: use_alpha,
        allGroups: _all_groups,
      }

    case rts.handleSelect_appDataItem:
      const { _itemKey: key } = action.item
      const _selectedInfo = { ...state.selectedInfo }
      const _same = key === _selectedInfo.appDataItemItem
      _selectedInfo.appDataItem = _same ? null : _selectedInfo.appData[key]
      _selectedInfo.appDataItemItem = _same ? null : key
      const _all_groups_2 = [...state.allGroups, { ...action.item, }]
      return {
        ...state,
        selectedInfo: _selectedInfo,
        allGroups: _all_groups_2
      }

    case rts.handleSet_appDataKeys:
      return { ...state, appDataKeys: value }

    case rts.handleSet_appLinkData:
      return { ...state, appLinkData: value }

    case rts.handleSet_backupData:
      return { ...state, backupData: value }

    case rts.handleSet_currentConfirmationType:
      return { ...state, currentConfirmationType: value }

    case rts.handleSet_currentDataLinks:
      return { ...state, currentDataLinks: value }

    case rts.handleSet_currentResults:
      return { ...state, currentResults: value }

    case rts.handleSet_selectedAppData:
      let useAlpha = false
      if (value && value.length >= _alphaLimit) {
        useAlpha = true;
      }
      return { ...state, selectedAppData: value, useAlpha }

    case rts.handleSet_selectedAppDataKey:
      return { ...state, selectedAppDataKey: value }

    case rts.handleSet_selectedCollection:
      return { ...state, selectedCollection: value }

    case rts.handleSet_selectedCollectionData:
      return { ...state, selectedCollectionData: value }

    case rts.handleSet_selectedInfo:
      return { ...state, selectedInfo: value }

    case rts.handleSet_selectedItems:
      return { ...state, selectedItems: value }

    case rts.handleSet_updating:
      return { ...state, updating: value }

    case rts.handleSet_useAlpha:
      return { ...state, useAlpha: value }

    case rts.handleSet_clientProfiles:
      return { ...state, clientProfiles: value }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action)

    default:
      return { ...state }
  }
}

export const appDataSidebarHandlers = (dispatch) => {
  return {
    handleInit: () => dispatch({ type: rts.handleInit }),

    handleGo_next: (item) => dispatch({ type: rts.handleGo_next, item }),
    handleGo_back: () => dispatch({ type: rts.handleGo_back }),
    handleGo_backTo: (index) => dispatch({ type: rts.handleGo_backTo, index }),

    handleSelect_appData: (item) => dispatch({ type: rts.handleSelect_appData, item }),
    handleSelect_appDataItem: (item) => dispatch({ type: rts.handleSelect_appDataItem, item }),

    handleSet_appDataKeys: (value) => dispatch({ type: rts.handleSet_appDataKeys, value }),
    handleSet_appLinkData: (value) => dispatch({ type: rts.handleSet_appLinkData, value }),
    handleSet_backupData: (value) => dispatch({ type: rts.handleSet_backupData, value }),
    handleSet_currentConfirmationType: (value) => dispatch({ type: rts.handleSet_currentConfirmationType, value }),
    handleSet_currentDataLinks: (value) => dispatch({ type: rts.handleSet_currentDataLinks, value }),
    handleSet_currentResults: (value) => dispatch({ type: rts.handleSet_currentResults, value }),
    handleSet_selectedAppData: (value) => dispatch({ type: rts.handleSet_selectedAppData, value }),
    handleSet_selectedAppDataKey: (value) => dispatch({ type: rts.handleSet_selectedAppDataKey, value }),
    handleSet_selectedCollection: (value) => dispatch({ type: rts.handleSet_selectedCollection, value }),
    handleSet_selectedCollectionData: (value) => dispatch({ type: rts.handleSet_selectedCollectionData, value }),
    handleSet_selectedInfo: (value) => dispatch({ type: rts.handleSet_selectedInfo, value }),
    handleSet_selectedItems: (value) => dispatch({ type: rts.handleSet_selectedItems, value }),
    handleSet_updating: (value) => dispatch({ type: rts.handleSet_updating, value }),
    handleSet_useAlpha: (value) => dispatch({ type: rts.handleSet_useAlpha, value }),
    handleSet_clientProfiles: (value) => dispatch({ type: rts.handleSet_clientProfiles, value })
  }
}

const getSelectedInfo = (key, state) => {
  const { currentResults, selectedInfo, aps_viewItems } = state

  const selected_info = { ...selectedInfo };
  const isSameSelection = key === selected_info.appDataItemKey;

  // Toggle selection state
  selected_info.appDataItemKey = isSameSelection ? null : key;

  // Update app data and view item based on new selection
  const selectedItemKey = selected_info.appDataItemKey;
  selected_info.appData = selectedItemKey ? _.cloneDeep(currentResults[selectedItemKey]) : [];
  selected_info.viewItem = aps_viewItems ? aps_viewItems[selectedItemKey] : {};
  selected_info.appDataItem = null;
  selected_info.appDataItemItem = null;

  // Extract unique properties and order app data
  const vi = aps_viewItems[selectedItemKey];
  const { dataConnection } = vi ?? {};
  const { uniqueProps } = dataConnection ?? {};

  const _selectedAppData = _.orderBy(
    selected_info.appData,
    [
      (item) => item?.selected,
      (item) => (item?.lastName || "").toLowerCase(),
      (item) => (item?.name || "").toLowerCase()
    ]
  );

  // Generate item keys and update state
  convertHelpers.createItemKeys(selected_info.appData);
  return { selected_info, _selectedAppData, uniqueProps, isSameSelection }
}

